// Copyright 2016 Sorama B.V.

import { ExtendedLifestyleServiceBase } from "services/Lifestyle/ExtendedLifestyleServiceBase";

export class ExtendedLifestyleService<TKey> extends ExtendedLifestyleServiceBase<TKey> {
    private updateAction: (key: TKey) => Promise<void>;
    private errorAction: (key: TKey, error: unknown) => void;

    constructor(
        updateAction: (key: TKey) => Promise<void>,
        errorAction: (key: TKey, error: unknown) => void,
        updateInterval: number
    ) {
        super(updateInterval);
        this.updateAction = updateAction;
        this.errorAction = errorAction;
    }

    public addKey(key: TKey): void {
        super.addKey(key);
    }

    public removeKey(key: TKey): void {
        super.removeKey(key);
    }

    protected onError(key: TKey, error: unknown): void {
        this.errorAction(key, error);
    }

    protected onUpdate(key: TKey): Promise<void> {
        return this.updateAction(key);
    }
}
